import PageMeta from "../components/common/PageMeta";
import PageContainer from "../components/common/PageContainer";
import PageHeader from "../components/common/PageHeader";
import ApiKeysManager from "../components/common/ApiKeysManager";

export default function ClientApiKeys() {
  return (
    <div>
      <PageMeta title="Chargemont | API Keys" description="Chargemont | API Keys" />
      <PageContainer>
        <PageHeader title="API Keys" />
        <ApiKeysManager apiBaseUrl="/api/client-api-keys" />
      </PageContainer>
    </div>
  );
}
